export enum Key {
  unidentified = 'Unidentified',
  enter = 'Enter',
  backspace = 'Backspace',
  tab = 'Tab',
  arrowLeft = 'ArrowLeft',
  arrowTop = 'ArrowTop',
  arrowRight = 'ArrowRight',
  arrowBottom = 'ArrowBottom',
  zero = '0',
  one = '1',
  two = '2',
  three = '3',
  four = '4',
  five = '5',
  six = '6',
  seven = '7',
  eight = '8',
  nine = '9',
  v = 'v'
}

export enum Modifier {
  altKey = 'altKey',
  ctrlKey = 'ctrlKey',
  shiftKey = 'shiftKey',
  metaKey = 'metaKey'
}
